import { useTranslation } from 'next-i18next'
// Dependencies.
import styled, { css } from 'styled-components'

import { Section } from '../Section'
import { H2 } from '../H2'
import { H3 } from '../H3'
import { P } from '../P'
import { forScreensGreaterThanMobileWidth } from '../../utils'

// Props.
interface Props {}

// Keep The Klyk Strong.
export const TLDRPartyRules: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // Steps Data

  const rulesData = [
    {
      bgColor: '#FDF6D2',
      header: t('Law-breaking', 'Law-breaking'),
      content: t(
        'Klyk prohibits any content, behaviour or activity, or the encouragement of any activity that is in violation of the law.',
        'Klyk prohibits any content, behaviour or activity, or the encouragement of any activity that is in violation of the law.',
      ),
    },
    {
      bgColor: '#FDF0E3',
      header: t('Explicit conduct', 'Explicit conduct'),
      content: t(
        'Any sexually explicit content, including pornography and nudity, are banned on Klyk. Any person in violation of this rule will be removed from their events and face possible account suspension.',
        'Any sexually explicit content, including pornography and nudity, are banned on Klyk. Any person in violation of this rule will be removed from their events and face possible account suspension.',
      ),
    },
    {
      bgColor: '#FAFAFE',
      header: t('Invading privacy', 'Invading privacy'),
      content: t(
        'Misleading others or providing fake information with malicious intent is not acceptable behaviour. Trolling, impersonation or revealing people’s personal information without their consent are considered invasions of privacy and are not in line with Klyk’s values nor Terms of Use.',
        'Misleading others or providing fake information with malicious intent is not acceptable behaviour. Trolling, impersonation or revealing people’s personal information without their consent are considered invasions of privacy and are not in line with Klyk’s values nor Terms of Use.',
      ),
    },
    {
      bgColor: '#EDFCFD',
      header: t('Threatening behaviour', 'Threatening behaviour'),
      content: t(
        'Klyk does not tolerate threatening behaviour of any kind including - harassment, stalking, predatory behaviour or sexually predatory behaviour, intimidation, acts of violence, coercion or inciting threatening or aggressive behaviour. To violate this rule is to violate the Terms of Use and your Klyk account will be in jeopardy.',
        'Klyk does not tolerate threatening behaviour of any kind including - harassment, stalking, predatory behaviour or sexually predatory behaviour, intimidation, acts of violence, coercion or inciting threatening or aggressive behaviour. To violate this rule is to violate the Terms of Use and your Klyk account will be in jeopardy.',
      ),
    },
    {
      bgColor: '#E8F1F4',
      header: t('Mutual respect', 'Mutual respect'),
      content: t(
        'Social connection is built on a foundation of respect for the individual. Get the most out of Klyk by playing nice, being friendly and respecting people you interact with on the platform.',
        'Social connection is built on a foundation of respect for the individual. Get the most out of Klyk by playing nice, being friendly and respecting people you interact with on the platform.',
      ),
    },
  ]
  return (
    <Div>
      <Section>
        <div className="contentContainer">
          <P>
            {t(
              `TLDRPartyRules-1898251135`,
              `Klyk should be a safe space for people to connect with one another and share experiences together. Help us keep it that way so that it can be enjoyed by many. We ask that you keep your events and interactions above board and avoid any activity that presents harm to yourself or anyone else. Thanks for using Klyk the way it was intended.`,
            )}
          </P>
          <H2>{t(`Klyk guidelines`, `Klyk guidelines`)}</H2>
          <P className="partyRules">
            {t(
              `TLDRPartyRules-935981878`,
              `In the event that you are unsure of what behaviour we deem to be inappropriate, we’ve assembled these community guidelines to follow. It’s not rocket science (unless you’re teaching a class on rocket science) but we consider it of paramount importance that each and every user abides by these guidelines so that Klyk can remain a place where people feel comfortable to socialise and engage in conversation with people they know or perhaps are getting to know. By using Klyk, you are agreeing to these community guidelines and our Terms of Use. Klyk responsibly, everyone.`,
            )}
          </P>
        </div>
        <div className="rules">
          {rulesData.map((rule, index) => (
            <Rule
              key={index}
              bgColor={rule.bgColor}
              header={rule.header}
              content={rule.content}
            />
          ))}
        </div>
      </Section>
    </Div>
  )
}

interface RuleProps {
  className?: string
  bgColor: string
  header: string
  content: string
}

const Rule: React.FC<RuleProps> = (props) => {
  const { className, bgColor, header, content } = props
  return (
    <StyledRule style={{ backgroundColor: `${bgColor}` }}>
      <H3>{header}</H3>
      <P>{content}</P>
    </StyledRule>
  )
}

// Div.
const Div = styled.div`
  /* padding-top: 60px; */

  .contentContainer {
    margin: 0 auto;
    width: 100%;
    max-width: 664px;
  }

  h2:nth-of-type(2) {
    margin-top: 60px;
  }

  .partyRules {
    font-size: 24px;
  }

  .rules {
    width: 100%;
    margin: 60px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    ${forScreensGreaterThanMobileWidth(css`
      width: 82%;
    `)}
  }
`

const StyledRule = styled.div`
  box-sizing: border-box;
  margin-top: 20px;
  padding: 30px;
  border-radius: 10px;
  ${forScreensGreaterThanMobileWidth(
    css`
      width: calc(50% - 10px);
    `,
  )}
  h3 {
    text-align: left;
  }

  p {
    margin-top: 20px;
  }
`
